<template>
  <button :class="'button__alert ' + alertColorLevel" type="button" @click="toggleIsModalOpened(true)">
    <FontAwesomeIcon :icon="'fa-light fa-' + alertIconLevel" />
  </button>
  <FormAlertsModalComponent
    :opened="isModalOpened"
    :alerts="alerts"
    :name="name"
    @hidden="toggleIsModalOpened(false)"
  />
</template>

<script>
import FormAlertsModalComponent from "@/components/form/alert/FormAlertsModalComponent.vue";
import { alertManager } from "@/services/alert/alert-manager";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "FormAlertsComponent",
  components: { FontAwesomeIcon, FormAlertsModalComponent },
  props: {
    alerts: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  emits: ["toggleTab"],
  data() {
    return {
      isModalOpened: false,
    };
  },
  computed: {
    alertColorLevel() {
      const alertLevel = alertManager.setAlertColorLevel(this.alerts);
      return alertManager.getAlertColor(alertLevel);
    },

    alertIconLevel() {
      const alertLevel = alertManager.setAlertColorLevel(this.alerts);
      return alertManager.getAlertIcon(alertLevel);
    },
  },
  watch: {},
  mounted() {},
  methods: {
    toggleTab(payload) {
      this.$emit("toggleTab", payload);
    },

    toggleIsModalOpened(value) {
      this.isModalOpened = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  &__alert {
    margin-left: 10px;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    border: none;
    border-left: 4px solid;
    font-weight: 600;

    &.-info {
      background: $light-purple;
      color: $purple;
      border-color: $purple;

      @include dark-theme {
        background: $purple;
        color: $light-purple;
        border-color: $light-purple;
      }
    }

    &.-warning {
      background: $light-orange;
      color: $orange;
      border-color: $orange;

      @include dark-theme {
        background: $orange;
        color: $light-orange;
        border-color: $light-orange;
      }
    }

    &.-danger {
      background: $light-red;
      color: $red;
      border-color: $red;

      @include dark-theme {
        background: $red;
        color: $light-red;
        border-color: $light-red;
      }
    }
  }
}
</style>
